
  import {Component, Vue, Watch} from "vue-property-decorator";
import { getOperationNameByMac } from "@/api/monitorGateway";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
import { LogHelper } from "@/common/LogHelper";
import {cloudPress, repaitFactorySearch} from "@/api/service";
  import Enumerable from "linq";

@Component({
  name: "Form1",
})
export default class extends Vue {
  private inputModel: inputDataModel_RepairSupply = {
    input_ScanCode: "",
    repairFactory: "",
    repairFactoryLable:"",
    circleLine: 0,
    maxLatticeNo: 0,
    deviceAttribute: 0
  };
  public globalConfig: any = {};
  public latticeNoRequired = false;

  @Watch("inputModel.repairFactory", {deep: false})
  onPackageNameChanged(val: string, oldVal: string) {
    debugger;
    let c = Enumerable.from(this.repairFactoryList);
    let item:any = c.firstOrDefault(  f=> f.value === this.inputModel.repairFactory);

    if (item)
    {
      console.log("*************" + item.value + ";" + item.label);
      this.inputModel.repairFactoryLable = item.label;
    }
  }

  //维修工厂列表
  public repairFactoryList:any = [];
  mounted() {
    this.globalConfig = SystemConfigModule.globalData;
    try {
      this.inputModel.repairFactory = "";
    } catch (error) {
      console.log(error);
    }
    this.$emit("get-form1-value", this.inputModel);

    debugger
    let _request = {
      pageNum: "0",
      pageSize: "0",
      searchKey:"0"
    };
    let stReturnStr = JSON.parse(repaitFactorySearch(JSON.stringify(_request)));
    let repairList = [];
    for (
      let iIndex = 0;
      iIndex < stReturnStr.data.length;
      iIndex++
    ) {
      repairList.push({
        value: stReturnStr.data[iIndex].repairFactoryCode,
        label: stReturnStr.data[iIndex].repairFactoryName,
      });
    }
    this.repairFactoryList = repairList;
  }

}
